export enum ProgressActionTypes {
  SET_PROGRESS = 'SET_PROGRESS',
  SET_FLAG = 'SET_FLAG',
}
